import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MonitorHeartOutlined,
  BarChartOutlined,
  BoltOutlined,
  InsightsOutlined,
  FileDownloadOutlined,
  VerifiedUserOutlined,
} from '@mui/icons-material';
import { Trans, useTranslation } from 'react-i18next';
import styles from './_shared.module.scss';

const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      {/* Hero */}
      <section className={styles.hero}>
        <div className={styles.heroGridOverlay} />
        <div className={styles.heroInner}>
          <div>
            <span className={styles.eyebrow}>{t('guide.home.eyebrow')}</span>
            <h1 className={styles.heroTitle}>
              <span className={styles.brandGradient}>GRAP</span>
            </h1>
            <p className={styles.heroSubtitle}>
              <Trans i18nKey="guide.home.subtitle" />
            </p>
            <div className={styles.heroActions}>
              <button className={styles.btnPrimary} onClick={() => navigate('/history')}>
                {t('guide.home.start')}
              </button>
              <button className={styles.btnSecondary} onClick={() => navigate('/sosguide')}>
                {t('guide.home.viewGuide')}
              </button>
            </div>
          </div>
          <div className={styles.heroBadge}>
            <InsightsOutlined />
          </div>
        </div>
      </section>

      {/* Core Features */}
      <section className={styles.section}>
        <header className={styles.sectionHeader}>
          <span className={styles.sectionEyebrow}>{t('guide.home.coreEyebrow')}</span>
          <h2 className={styles.sectionTitle}>{t('guide.home.coreTitle')}</h2>
          <p className={styles.sectionLead}>
            {t('guide.home.coreLead')}
          </p>
        </header>
        <div className={styles.featureGrid}>
          <article className={styles.featureCard}>
            <div className={styles.featureIcon}><MonitorHeartOutlined /></div>
            <span className={styles.featureTag}>GWSOS</span>
            <h3 className={styles.featureTitle}>{t('guide.home.sosTitle')}</h3>
            <p className={styles.featureDesc}>
              {t('guide.home.sosDesc')}
            </p>
            <ul className={styles.featureBullets}>
              <li>{t('guide.home.sosBullet1')}</li>
              <li>{t('guide.home.sosBullet2')}</li>
              <li>{t('guide.home.sosBullet3')}</li>
            </ul>
          </article>

          <article className={styles.featureCard}>
            <div className={styles.featureIcon}><BarChartOutlined /></div>
            <span className={styles.featureTag}>GWSAR</span>
            <h3 className={styles.featureTitle}>{t('guide.home.sarTitle')}</h3>
            <p className={styles.featureDesc}>
              {t('guide.home.sarDesc')}
            </p>
            <ul className={styles.featureBullets}>
              <li>{t('guide.home.sarBullet1')}</li>
              <li>{t('guide.home.sarBullet2')}</li>
              <li>{t('guide.home.sarBullet3')}</li>
            </ul>
          </article>
        </div>
      </section>

      {/* Benefits */}
      <section className={styles.section}>
        <header className={styles.sectionHeader}>
          <span className={styles.sectionEyebrow}>{t('guide.home.whyEyebrow')}</span>
          <h2 className={styles.sectionTitle}>{t('guide.home.whyTitle')}</h2>
        </header>
        <div className={styles.benefitGrid}>
          <div className={styles.benefitCard}>
            <div className={styles.benefitIcon}><BoltOutlined /></div>
            <h4 className={styles.benefitTitle}>{t('guide.home.benefit1Title')}</h4>
            <p className={styles.benefitDesc}>{t('guide.home.benefit1Desc')}</p>
          </div>
          <div className={styles.benefitCard}>
            <div className={styles.benefitIcon}><InsightsOutlined /></div>
            <h4 className={styles.benefitTitle}>{t('guide.home.benefit2Title')}</h4>
            <p className={styles.benefitDesc}>{t('guide.home.benefit2Desc')}</p>
          </div>
          <div className={styles.benefitCard}>
            <div className={styles.benefitIcon}><FileDownloadOutlined /></div>
            <h4 className={styles.benefitTitle}>{t('guide.home.benefit3Title')}</h4>
            <p className={styles.benefitDesc}>{t('guide.home.benefit3Desc')}</p>
          </div>
          <div className={styles.benefitCard}>
            <div className={styles.benefitIcon}><VerifiedUserOutlined /></div>
            <h4 className={styles.benefitTitle}>{t('guide.home.benefit4Title')}</h4>
            <p className={styles.benefitDesc}>{t('guide.home.benefit4Desc')}</p>
          </div>
        </div>
      </section>

      {/* Closing */}
      <section className={styles.closing}>
        <div className={styles.closingBox}>
          <h2>{t('guide.home.closingTitle')}</h2>
          <p>{t('guide.home.closingDesc')}</p>
          <button className={styles.btnPrimary} onClick={() => navigate('/sosguide')}>
            {t('guide.home.closingButton')}
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
